import React from 'react';
import sizeDepth from 'assets/images/size/depth.svg';
import sizeWidth from 'assets/images/size/width.svg';
import {
  marksDepth,
  marksWidth,
} from 'containers/Ribbon/CabinetRibbon/constants';
import DimensionCabinetSelector from 'containers/Ribbon/CabinetRibbon/DimensionCabinetSelector';
import CornerSelector from 'containers/Ribbon/CabinetRibbon/CornerSelector';
import SupportOptions from 'containers/SupportPanel/SupportOptions';
import { useTranslation } from 'react-i18next';
import MobileMenu from 'components/MobileMenu';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/Ribbon/ShelvesRibbon/types';
import { makeSelectActivePanel } from 'containers/Configurator/selectors/general';
import { useSelector } from 'react-redux';
import { makeSelectRibbonIsMobileMenuOpen } from '../selectors';
import { ActivePanel } from '../../Configurator/constants/general';
import UpperShelfPanelContent from '../../UpperShelfPanel/UpperShelfPanelContent';

type Selection = 'width' | 'depth' | 'corners' | 'support' | 'upperShelf';

interface Props {
  width: number;
  depth: number;
  updateCabinetWidth: any;
  updateCabinetDepth: any;
}

interface StateProps {
  mobilePanelOpen: ActivePanel | undefined;
  isMobileMenuOpen: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  mobilePanelOpen: makeSelectActivePanel(),
  isMobileMenuOpen: makeSelectRibbonIsMobileMenuOpen(),
});

function MobileMenuCabinet(props: Props) {
  const { t } = useTranslation();

  const { mobilePanelOpen, isMobileMenuOpen } = useSelector(stateSelector);

  // list of items
  const list = [
    { name: t('Width'), key: 'width' },
    { name: t('Depth'), key: 'depth' },
    { name: t('Corners'), key: 'corners' },
    { name: t('Support'), key: 'support' },
    { name: t('Upper shelf'), key: 'upperShelf' },
  ];

  function cabinetEdit(selected: Selection) {
    switch (selected) {
      case 'width':
        return (
          <DimensionCabinetSelector
            value={props.width}
            icon={sizeWidth}
            handleInput={props.updateCabinetWidth}
            min={marksWidth[0].value}
            max={marksWidth[marksWidth.length - 1].value}
            marks={marksWidth}
          />
        );
      case 'depth':
        return (
          <DimensionCabinetSelector
            value={props.depth}
            icon={sizeDepth}
            handleInput={props.updateCabinetDepth}
            min={marksDepth[0].value}
            max={marksDepth[marksDepth.length - 1].value}
            marks={marksDepth}
          />
        );
      case 'corners':
        return <CornerSelector />;
      case 'support':
        return <SupportOptions />;
      case 'upperShelf':
        return <UpperShelfPanelContent />;
    }
  }

  return (
    <MobileMenu
      initialSelection={isMobileMenuOpen ? 'width' : null}
      list={list}
      cabinetEdit={cabinetEdit}
      panelOpen={mobilePanelOpen !== undefined}
    />
  );
}

export default MobileMenuCabinet;
